import script from "./PresentationView.vue?vue&type=script&setup=true&lang=js"
export * from "./PresentationView.vue?vue&type=script&setup=true&lang=js"

import "./PresentationView.vue?vue&type=style&index=0&id=7a3fd278&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a3fd278"]])

export default __exports__